import styled from 'styled-components';

export const Payouts = styled.div`
  text-align: right;
  min-width: 150px;
`;

export const PayoutCurrency = styled.div`
  font-weight: bold;
`;
